import { FC, useState } from 'react';

import { Tab } from '@headlessui/react';

import { useDialog } from 'hooks/useDialog';
import { useGetProgressData } from 'hooks/useGetProgressData';
import { usePageTitle } from 'hooks/usePageTitle';
import { usePrize } from 'hooks/usePrize';

import { CompletedArea } from 'components/features/CompletedArea';
import { Button } from 'components/parts/Button';
import { Dialog } from 'components/parts/Dialog/Dialog';
import { HamadoriHeadline } from 'components/parts/HamadoriHeadline';
import { SPECIAL_AREA_MISSION_IDS } from 'constants/mission';
import { PRIZE_MIN_AREA_CLEAR } from 'constants/prize';
import CloseIcon from 'images/icon/close_cocoa.svg';
import CloseIconWhite from 'images/icon/close_white.svg';
import BgTitle from 'images/prizes/bg_title.svg';
import { useGetPrizeQuery } from 'store/prize';
import { Prize, Award } from 'types/prize';

import styles from './Prizes.module.scss';
type CurrentPrizeData = {
  prize: Prize;
  award: string;
  url: string;
  index: number;
};

const isAllSpecialAreasCompleted = (completedAreaList: number[] = []) => {
  return SPECIAL_AREA_MISSION_IDS.every(specialId =>
    completedAreaList.some(completedId => String(completedId) === specialId)
  );
};

export const Prizes: FC = () => {
  const {
    isOpen: isOpenPrize,
    handleOpen: handleOpenPrize,
    handleClose: handleClosePrize,
  } = useDialog();
  const {
    isOpen: isOpenApply,
    handleOpen: handleOpenApply,
    handleClose: handleCloseApply,
  } = useDialog();
  const getPrizeResult = useGetPrizeQuery(undefined, { skip: false });
  const isRegularEntered = getPrizeResult?.data?.enteredPrize?.regular ? true : false;
  const isSpecialEntered = getPrizeResult?.data?.enteredPrize?.special ? true : false;
  const { data: progressData } = useGetProgressData();
  const [applyUrl, setApplyUrl] = useState('');
  const [currentPrizeData, setCurrentPrizeData] = useState<CurrentPrizeData | null>(null);
  const [selectedAward, setSelectedAward] = useState<string | null>(null);
  const prizeData = usePrize();
  const completedAreas = progressData?.completedAreaList.length || 0;
  const [currentTab, setCurrentTab] = useState(3);

  function getPrizeFileName(award: string, index: number) {
    const a = award === 'S賞' ? 's' : award === 'A賞' ? 'a' : award === 'B賞' ? 'b' : 'c';
    const i = index + 1;
    return `${a}_prize_${String(i).padStart(2, '0')}.webp`;
  }
  function getClassName(award: string) {
    const result =
      award === 'S賞'
        ? 'awardS'
        : award === 'A賞'
        ? 'awardA'
        : award === 'B賞'
        ? 'awardB'
        : 'awardC';
    return result;
  }

  function generatePrizeHTML() {
    const completedLength = progressData?.completedAreaList.length;

    if (completedLength === undefined) {
      console.log('undefined');
      return '';
    }

    if (isRegularEntered) {
      return (
        <div className={styles.tabsApply}>
          <Button
            text="応募済み"
            styleType="primary"
            addClass={[styles.spotButton]}
            disabled={true}
          />
        </div>
      );
    }

    if (completedLength < PRIZE_MIN_AREA_CLEAR.C) {
      return (
        <div className={styles.tabsApply}>
          <p className={styles.speechBubble}>1エリアクリアしよう</p>
          <Button
            text="賞品に応募"
            styleType="primary"
            handleClick={() => {
              handleApplyClick(prizeData?.awardC.url, prizeData?.awardC.award);
            }}
            addClass={[styles.spotButton]}
            disabled={true}
          />
        </div>
      );
    } else if (
      completedLength >= PRIZE_MIN_AREA_CLEAR.C &&
      completedLength < PRIZE_MIN_AREA_CLEAR.B
    ) {
      return (
        <div className={styles.tabsApply}>
          <p className={styles.speechBubble}>C賞が当たる</p>
          <Button
            text="賞品に応募"
            styleType="primary"
            handleClick={() => {
              handleApplyClick(prizeData?.awardC.url, prizeData?.awardC.award);
            }}
            addClass={[styles.spotButton]}
          />
        </div>
      );
    } else if (
      completedLength >= PRIZE_MIN_AREA_CLEAR.B &&
      completedLength < PRIZE_MIN_AREA_CLEAR.A
    ) {
      return (
        <div className={styles.tabsApply}>
          <p className={styles.speechBubble}>B・C賞が当たる</p>
          <Button
            text="賞品に応募"
            styleType="primary"
            handleClick={() => {
              handleApplyClick(prizeData?.awardB.url, prizeData?.awardB.award);
            }}
            addClass={[styles.spotButton]}
          />
        </div>
      );
    } else if (
      completedLength >= PRIZE_MIN_AREA_CLEAR.A &&
      completedLength < PRIZE_MIN_AREA_CLEAR.S
    ) {
      return (
        <div className={styles.tabsApply}>
          <p className={styles.speechBubble}>A・B・C賞が当たる</p>
          <Button
            text="賞品に応募"
            styleType="primary"
            handleClick={() => {
              handleApplyClick(prizeData?.awardA.url, prizeData?.awardA.award);
            }}
            addClass={[styles.spotButton]}
          />
        </div>
      );
    } else if (
      completedLength >= PRIZE_MIN_AREA_CLEAR.S &&
      completedLength < PRIZE_MIN_AREA_CLEAR.SS
    ) {
      return (
        <div className={styles.tabsApply}>
          <p className={styles.speechBubble}>S・A・B・C賞が当たる</p>
          <Button
            text="賞品に応募"
            styleType="primary"
            handleClick={() => {
              handleApplyClick(prizeData?.awardS.url, prizeData?.awardS.award);
            }}
            addClass={[styles.spotButton]}
          />
        </div>
      );
    } else if (completedLength >= PRIZE_MIN_AREA_CLEAR.SS) {
      return (
        <div className={styles.tabsApply}>
          <p className={styles.speechBubble}>当選確率2倍！</p>
          <Button
            text="賞品に応募"
            styleType="primary"
            handleClick={() => {
              handleApplyClick(prizeData?.awardSS.url, prizeData?.awardSS.award);
            }}
            addClass={[styles.spotButton]}
          />
        </div>
      );
    }
  }

  const handlePrizeClick = (prize: Prize, award: Award, index: number) => {
    setCurrentPrizeData({
      prize,
      award: award.award,
      url: award.url,
      index,
    });
    handleOpenPrize();
  };

  const handleApplyClick = (url: string | undefined, award: string | undefined) => {
    if (!url || !award) return;
    setApplyUrl(url);
    setSelectedAward(award);
    handleOpenApply();
  };

  const generateSvg = (text: string, active: boolean) => {
    // const color = active ? '#fff' : '#B4B4B7';
    let path = '';

    switch (text) {
      case 'S':
        path = `
          <svg width="42" height="25" viewBox="0 0 42 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.1556 4.52172C12.5216 4.52172 14.775 5.03088 16.9156 6.04922L17.9634 1.75922C15.6876 0.719219 13.0061 0.199219 9.91902 0.199219C7.01222 0.199219 4.74762 0.805885 3.12522 2.01922C1.52536 3.23255 0.725423 4.86838 0.725423 6.92672C0.725423 8.76838 1.40142 10.3176 2.75342 11.5742C4.10542 12.8092 6.32496 13.8601 9.41202 14.7267C10.6288 15.0734 11.4738 15.4634 11.947 15.8967C12.4428 16.3301 12.6906 16.8934 12.6906 17.5867C12.6906 18.4317 12.3864 19.0926 11.778 19.5692C11.1922 20.0242 10.3134 20.2517 9.14162 20.2517C6.66296 20.2517 4.27442 19.4934 1.97602 17.9767L0.624023 22.2992C1.66056 22.9709 2.94496 23.5234 4.47722 23.9567C6.00949 24.3684 7.48542 24.5742 8.90502 24.5742C12.0822 24.5742 14.482 23.9676 16.1044 22.7542C17.7268 21.5409 18.538 19.7859 18.538 17.4892C18.538 15.5392 17.8508 13.9467 16.4762 12.7117C15.1242 11.4767 12.7695 10.4151 9.41202 9.52672C7.51922 9.00672 6.57282 8.14005 6.57282 6.92672C6.57282 6.19005 6.87702 5.60505 7.48542 5.17172C8.09382 4.73838 8.98389 4.52172 10.1556 4.52172Z" fill="inherit"/><path fill-rule="evenodd" clip-rule="evenodd" d="M41.2727 21.9598C40.1565 21.5515 38.9735 21.184 37.7237 20.8573H39.7257V14.4698H25.6753V20.8573H27.9503C26.6763 21.2306 25.4084 21.5398 24.1465 21.7848L25.1475 23.7098C27.7683 23.1965 29.8249 22.549 31.3173 21.7673L30.7895 20.8573H34.6115L34.0837 21.9248C36.4376 22.5315 38.4214 23.1615 40.0351 23.8148L41.2727 21.9598ZM28.5873 19.3873V18.9148H36.8137V19.3873H28.5873ZM28.5873 17.7773V17.3223H36.8137V17.7773H28.5873ZM36.8137 16.1848H28.5873V15.7123H36.8137V16.1848Z" fill="inherit"/><path fill-rule="evenodd" clip-rule="evenodd" d="M36.5407 7.17229C36.2738 7.76728 36.0069 8.29812 35.7399 8.76479H34.1929V7.15479H31.2081V8.76479H29.7885C29.4973 8.20479 29.1879 7.67979 28.8603 7.18979L26.2759 7.67979C26.5671 8.14645 26.7855 8.50812 26.9311 8.76479H24.5469V13.0348H26.6399V14.1023H38.7611V13.0348H40.8541V8.76479H38.4881C38.7429 8.27479 38.9249 7.90729 39.0341 7.66228L36.5407 7.17229ZM35.9583 12.9648H29.4427V12.3873H35.9583V12.9648ZM38.0331 10.6373V11.0048H27.3679V10.6373H38.0331Z" fill="inherit"/></svg>
        `;
        break;
      case 'A':
        path = `
          <svg width="45" height="25" viewBox="0 0 45 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.82712 0.524414L0.478516 24.2494H6.46112L7.88072 19.1144H15.6885L17.1419 24.2494H23.2259L14.9111 0.524414H8.82712ZM14.5393 14.9219H9.06372L11.7677 5.30192H11.8353L14.5393 14.9219ZM44.5721 21.9603C43.4558 21.5519 42.2728 21.1844 41.0231 20.8578H43.0251V14.4703H28.9747V20.8578H31.2497C29.9757 21.2311 28.7078 21.5403 27.4459 21.7853L28.4469 23.7103C31.0677 23.1969 33.1243 22.5494 34.6167 21.7678L34.0889 20.8578H37.9109L37.3831 21.9253C39.737 22.5319 41.7208 23.1619 43.3345 23.8153L44.5721 21.9603ZM39.2577 12.9653H32.7421V12.3878H39.2577V12.9653ZM41.3325 10.6378V11.0053H30.6673V10.6378H41.3325ZM31.8867 19.3878V18.9153H40.1131V19.3878H31.8867ZM31.8867 17.7778V17.3228H40.1131V17.7778H31.8867ZM40.1131 16.1853H31.8867V15.7128H40.1131V16.1853ZM39.8401 7.17277C39.5732 7.76777 39.3062 8.29861 39.0393 8.76527H37.4923V7.15527H34.5075V8.76527H33.0879C32.7967 8.20527 32.4873 7.68027 32.1597 7.19027L29.5753 7.68027C29.8665 8.14694 30.0849 8.50861 30.2305 8.76527H27.8463V13.0353H29.9393V14.1028H32.7421H42.0605V13.0353H44.1535V8.76527H41.7875C42.0423 8.27527 42.2243 7.90777 42.3335 7.66277L39.8401 7.17277Z" fill="inherit"/></svg>
        `;
        break;
      case 'B':
        path = `
          <svg width="40" height="25" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.3789 22.8202C17.0239 21.6502 17.8463 19.8519 17.8463 17.4252C17.8463 15.9302 17.3168 14.6519 16.2577 13.5902C15.2212 12.5285 13.8016 11.8894 11.9989 11.6727V11.6077C13.5312 11.3694 14.7593 10.7627 15.6831 9.78769C16.607 8.8127 17.0689 7.64269 17.0689 6.27769C17.0689 2.22603 13.8016 0.200195 7.26695 0.200195C4.76575 0.200195 2.39975 0.362695 0.168945 0.687695V24.0877C2.51241 24.4127 4.99108 24.5752 7.60495 24.5752C11.1427 24.5752 13.734 23.9902 15.3789 22.8202ZM6.92895 9.91769H5.81355V4.5877C6.37688 4.4577 7.00781 4.3927 7.70635 4.3927C10.4779 4.3927 11.8637 5.29186 11.8637 7.0902C11.8637 8.9752 10.2188 9.91769 6.92895 9.91769ZM5.81355 20.1877V13.8827H7.36835C10.7709 13.8827 12.4721 14.8794 12.4721 16.8727C12.4721 18.0644 12.1003 18.9527 11.3567 19.5377C10.6131 20.101 9.44141 20.3827 7.84155 20.3827C7.14301 20.3827 6.46701 20.3177 5.81355 20.1877Z" fill="inherit"/><path fill-rule="evenodd" clip-rule="evenodd" d="M39.9721 21.9608C38.8559 21.5524 37.6729 21.1849 36.4231 20.8583H38.4251V14.4708H24.3747V20.8583H26.6497C25.3757 21.2316 24.1078 21.5408 22.8459 21.7858L23.8469 23.7108C26.4677 23.1974 28.5243 22.5499 30.0167 21.7683L29.4889 20.8583H33.3109L32.7831 21.9258C35.137 22.5324 37.1208 23.1624 38.7345 23.8158L39.9721 21.9608ZM27.2867 19.3883V18.9158H35.5131V19.3883H27.2867ZM27.2867 17.7783V17.3233H35.5131V17.7783H27.2867ZM35.5131 16.1858H27.2867V15.7133H35.5131V16.1858Z" fill="inherit"/><path fill-rule="evenodd" clip-rule="evenodd" d="M35.2401 7.17326C34.9732 7.76826 34.7063 8.2991 34.4393 8.76576H32.8923V7.15576H29.9075V8.76576H28.4879C28.1967 8.20576 27.8873 7.68076 27.5597 7.19076L24.9753 7.68076C25.2665 8.14743 25.4849 8.50909 25.6305 8.76576H23.2463V13.0358H25.3393V14.1033H37.4605V13.0358H39.5535V8.76576H37.1875C37.4423 8.27576 37.6243 7.90826 37.7335 7.66326L35.2401 7.17326ZM34.6577 12.9658H28.1421V12.3883H34.6577V12.9658ZM36.7325 10.6383V11.0058H26.0673V10.6383H36.7325Z" fill="inherit"/></svg>
        `;
        break;
      case 'C':
        path = `
          <svg width="44" height="25" viewBox="0 0 44 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.85744 6.70019C10.232 5.33519 12.1022 4.65269 14.4682 4.65269C16.4286 4.65269 18.3665 5.24853 20.2818 6.44019L21.9042 2.41019C19.6509 0.936862 16.9807 0.200195 13.8936 0.200195C9.83764 0.200195 6.66044 1.28353 4.36204 3.45019C2.08618 5.61686 0.948242 8.59603 0.948242 12.3877C0.948242 16.136 2.11998 19.1044 4.46344 21.2927C6.82944 23.481 9.97284 24.5752 13.8936 24.5752C16.9807 24.5752 19.6509 23.8385 21.9042 22.3652L20.2818 18.3352C18.3665 19.5269 16.4286 20.1227 14.4682 20.1227C12.2149 20.1227 10.3784 19.4294 8.95884 18.0427C7.53924 16.656 6.82944 14.771 6.82944 12.3877C6.82944 9.96103 7.50544 8.06519 8.85744 6.70019Z" fill="inherit"/><path fill-rule="evenodd" clip-rule="evenodd" d="M43.5723 21.9608C42.4561 21.5524 41.2731 21.1849 40.0233 20.8583H42.0253V14.4708H27.9749V20.8583H30.2499C28.9759 21.2316 27.708 21.5408 26.4461 21.7858L27.4471 23.7108C30.0679 23.1974 32.1245 22.5499 33.6169 21.7683L33.0891 20.8583H36.9111L36.3833 21.9258C38.7372 22.5324 40.721 23.1624 42.3347 23.8158L43.5723 21.9608ZM30.8869 19.3883V18.9158H39.1133V19.3883H30.8869ZM30.8869 17.7783V17.3233H39.1133V17.7783H30.8869ZM39.1133 16.1858H30.8869V15.7133H39.1133V16.1858Z" fill="inherit"/><path fill-rule="evenodd" clip-rule="evenodd" d="M38.8403 7.17326C38.5734 7.76826 38.3065 8.2991 38.0395 8.76576H36.4925V7.15576H33.5077V8.76576H32.0881C31.7969 8.20576 31.4875 7.68076 31.1599 7.19076L28.5755 7.68076C28.8667 8.14743 29.0851 8.50909 29.2307 8.76576H26.8465V13.0358H28.9395V14.1033H41.0607V13.0358H43.1537V8.76576H40.7877C41.0425 8.27576 41.2245 7.90826 41.3337 7.66326L38.8403 7.17326ZM38.2579 12.9658H31.7423V12.3883H38.2579V12.9658ZM40.3327 10.6383V11.0058H29.6675V10.6383H40.3327Z" fill="inherit"/></svg>
        `;
        break;
      default:
        throw new Error(`Invalid text: ${text}`);
    }

    return path;
  };

  usePageTitle(`賞品`);

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.head}>
          <h1 className={styles.title}>
            <img src={BgTitle} alt="豪華賞品に応募しよう" className={styles.titleImage} />
          </h1>
          <p className={styles.text1}>
            クリアしたエリアの合計数が多いほど
            <br />
            <strong>応募できる賞品が増えるよ！</strong>
          </p>
          <div className={styles.completedArea}>
            <CompletedArea completedAreas={completedAreas} isPrize={true} />
          </div>
        </div>
        <div className={styles.body}>
          <Tab.Group
            defaultIndex={3}
            onChange={index => {
              setCurrentTab(index);
            }}
          >
            <Tab.List className={styles.tabs} data-tabs-award={currentTab}>
              <Tab className={[styles.tab, styles.tabC].join(' ')}>
                <span
                  dangerouslySetInnerHTML={{ __html: generateSvg('C', true) }}
                  className={styles.tabInner}
                ></span>
              </Tab>
              <Tab className={[styles.tab, styles.tabB].join(' ')}>
                <span
                  dangerouslySetInnerHTML={{ __html: generateSvg('B', true) }}
                  className={styles.tabInner}
                ></span>
              </Tab>
              <Tab className={[styles.tab, styles.tabA].join(' ')}>
                <span
                  dangerouslySetInnerHTML={{ __html: generateSvg('A', true) }}
                  className={styles.tabInner}
                ></span>
              </Tab>
              <Tab className={[styles.tab, styles.tabS].join(' ')}>
                <span
                  dangerouslySetInnerHTML={{ __html: generateSvg('S', true) }}
                  className={styles.tabInner}
                ></span>
              </Tab>
            </Tab.List>
            <Tab.Panels className={styles.tabsContents} data-tabs-award={currentTab}>
              <Tab.Panel>
                {prizeData?.awardC && (
                  <div className={styles.tabsContent}>
                    <div className={styles.tabsContentInner}>
                      <div className={styles.tabsContentListWrap}>
                        <div className={styles.tabsContentList}>
                          {prizeData.awardC.prizes.map(
                            (prize, index) => (
                              <div key={index} className={styles.tabsContentItem}>
                                <button
                                  key={prize.name}
                                  onClick={() => handlePrizeClick(prize, prizeData.awardC, index)}
                                  className={styles.tabsAction}
                                  data-award={getClassName(prize.name)}
                                >
                                  <div className={styles.tabsHead}>
                                    <div className={styles.tabsImageBox}>
                                      <img
                                        src={require(`components/pages/Prizes/images/${getPrizeFileName(
                                          prizeData.awardC.award,
                                          index
                                        )}`)}
                                        alt={prize.name}
                                      />
                                    </div>
                                    <span className={styles.tabsWinnerCount}>
                                      {prize.winnerCount}
                                    </span>
                                  </div>
                                  <div className={styles.tabsBody}>
                                    <span
                                      className={styles.tabsName}
                                      dangerouslySetInnerHTML={{ __html: prize.name }}
                                    />
                                  </div>
                                </button>
                              </div>
                            ),
                            []
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Tab.Panel>
              <Tab.Panel>
                {prizeData?.awardB && (
                  <div className={styles.tabsContent}>
                    <div className={styles.tabsContentInner}>
                      <div className={styles.tabsContentListWrap}>
                        <div className={styles.tabsContentList}>
                          {prizeData.awardB.prizes.map(
                            (prize, index) => (
                              <div key={index} className={styles.tabsContentItem}>
                                <button
                                  key={prize.name}
                                  onClick={() => handlePrizeClick(prize, prizeData.awardB, index)}
                                  className={styles.tabsAction}
                                  data-award={getClassName(prize.name)}
                                >
                                  <div className={styles.tabsHead}>
                                    <div className={styles.tabsImageBox}>
                                      <img
                                        src={require(`components/pages/Prizes/images/${getPrizeFileName(
                                          prizeData.awardB.award,
                                          index
                                        )}`)}
                                        alt={prize.name}
                                      />
                                    </div>
                                    <span className={styles.tabsWinnerCount}>
                                      {prize.winnerCount}
                                    </span>
                                  </div>
                                  <div className={styles.tabsBody}>
                                    <span
                                      className={styles.tabsName}
                                      dangerouslySetInnerHTML={{ __html: prize.name }}
                                    />
                                  </div>
                                </button>
                              </div>
                            ),
                            []
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Tab.Panel>
              <Tab.Panel>
                {prizeData?.awardA && (
                  <div className={styles.tabsContent}>
                    <div className={styles.tabsContentInner}>
                      <div className={styles.tabsContentListWrap}>
                        <div className={styles.tabsContentList}>
                          {prizeData.awardA.prizes.map(
                            (prize, index) => (
                              <div key={index} className={styles.tabsContentItem}>
                                <button
                                  key={prize.name}
                                  // A賞は商品説明がないのでモーダルを開かない
                                  // onClick={() => handlePrizeClick(prize, prizeData.awardA, index)}
                                  className={styles.tabsAction}
                                  data-award={getClassName(prize.name)}
                                >
                                  <div className={styles.tabsHead}>
                                    <div className={styles.tabsImageBox}>
                                      <img
                                        src={require(`components/pages/Prizes/images/${getPrizeFileName(
                                          prizeData.awardA.award,
                                          index
                                        )}`)}
                                        alt={prize.name}
                                      />
                                    </div>
                                    <span className={styles.tabsWinnerCount}>
                                      {prize.winnerCount}
                                    </span>
                                  </div>
                                  <div className={styles.tabsBody}>
                                    <span
                                      className={styles.tabsName}
                                      dangerouslySetInnerHTML={{ __html: prize.name }}
                                    />
                                  </div>
                                </button>
                              </div>
                            ),
                            []
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Tab.Panel>
              <Tab.Panel>
                {prizeData?.awardS && (
                  <div className={styles.tabsContent}>
                    <div className={styles.tabsContentInner}>
                      <div className={styles.tabsContentListWrap}>
                        <div className={styles.tabsContentList}>
                          {prizeData.awardS.prizes.map(
                            (prize, index) => (
                              <div key={index} className={styles.tabsContentItem}>
                                <button
                                  key={prize.name}
                                  // S賞は商品説明がないのでモーダルを開かない
                                  // onClick={() => handlePrizeClick(prize, prizeData.awardS, index)}
                                  className={styles.tabsAction}
                                  data-award={getClassName(prize.name)}
                                >
                                  <div className={styles.tabsHead}>
                                    <div className={styles.tabsImageBox}>
                                      <img
                                        src={require(`components/pages/Prizes/images/${getPrizeFileName(
                                          prizeData.awardS.award,
                                          index
                                        )}`)}
                                        alt={prize.name}
                                      />
                                    </div>
                                    <span className={styles.tabsWinnerCount}>
                                      {prize.winnerCount}
                                    </span>
                                  </div>
                                  <div className={styles.tabsBody}>
                                    <span
                                      className={styles.tabsName}
                                      dangerouslySetInnerHTML={{ __html: prize.name }}
                                    />
                                  </div>
                                </button>
                              </div>
                            ),
                            []
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
        <div className={[styles.action, isRegularEntered && styles.prizeEntered].join(' ')}>
          {generatePrizeHTML()}
        </div>
        <div className={styles.foot}>
          <p className={styles.footImage}>
            <img
              src={require('images/prizes/prize-guide.webp')}
              alt="エリアクリア数ごとに応募できる賞品"
            />
          </p>
          <img
            src={require('images/character/chara-clear.webp')}
            alt=""
            className={styles.footCharacter}
          />
          <ul className={styles.notes}>
            <li>クリアしたエリアの合計数が多いほど、当選対象の賞品が増えます。</li>
            <li>賞品はイメージであり、予告なく変更となる場合があります。</li>
            <li>酒類は20歳以上が当選の対象となります。</li>
            <li>当選賞品は選べません。あらかじめご了承願います。</li>
            <li>当選発表は賞品の発送をもって代えさせていただきます。</li>
            <li>発送賞品の受け取りを拒否された場合、当選を辞退されたと見なします。</li>
            <li>
              お客様からお預かりした個人情報は、賞品の発送及び個人を特定しない統計資料としてのみ使用いたします。
            </li>
          </ul>
        </div>
        <div className={`${styles.body} ${styles.hamadoriBody}`} data-tabs-award="4">
          <div className={styles.hamadoriHeadBackground} />
          <HamadoriHeadline className={styles.hamadoriHeadline}>
            <h2 className={styles.hamadoriTitle}>浜通り賞</h2>
          </HamadoriHeadline>
          <p className={styles.hamadoriText}>
            浜通り賞とは… <br />
            全9エリアある浜通りエリアを全てクリアすると応募できる賞品です。
          </p>
          <p className={styles.hamadoriText}>＜対象エリア＞</p>
          <ul className={styles.hamadoriList}>
            <li>相馬市・南相馬市・飯舘村</li>
            <li>広野町</li>
            <li>楢葉町・川内村</li>
            <li>富岡町</li>
            <li>大熊町</li>
            <li>双葉町</li>
            <li>浪江町・葛尾村</li>
            <li>新地町</li>
            <li>いわき市</li>
          </ul>
          <div className={styles.hamadoriCharactorBox}>
            <img
              src={require('images/character/chara-eat.webp')}
              alt=""
              className={styles.hamadoriCharacter}
            />
          </div>
          <div className={styles.progressArea}>
            <CompletedArea
              placeholder="浜通り賞"
              totalAreas={SPECIAL_AREA_MISSION_IDS.length}
              completedAreas={
                progressData?.completedAreaList.filter(completedId =>
                  SPECIAL_AREA_MISSION_IDS.some(specialId => String(completedId) === specialId)
                ).length || 0
              }
              isPrize={false}
              withAreaUnit={true}
              altBarColor
            />
          </div>
          <div className={styles.tabsContent}>
            <div className={styles.tabsContentInner}>
              {prizeData?.awardSpecial &&
                prizeData.awardSpecial.prizes.map((prize, index) => (
                  <div key={index} className={styles.tabsContentItem}>
                    <div className={styles.tabsHead}>
                      {prize.image && (
                        <div className={styles.tabsImageBox}>
                          <img src={prize.image.url} alt={prize.name} />
                        </div>
                      )}
                      <span className={styles.tabsWinnerCount}>{prize.winnerCount}</span>
                    </div>
                    <div className={styles.tabsBody}>
                      <span
                        className={styles.tabsName}
                        dangerouslySetInnerHTML={{ __html: prize.name }}
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className={styles.hamadoriAction}>
            <div className={styles.tabsApply}>
              {isSpecialEntered ? (
                <Button
                  text="応募済み"
                  styleType="primary"
                  addClass={[styles.spotButton]}
                  disabled={true}
                />
              ) : !isAllSpecialAreasCompleted(progressData?.completedAreaList) ? (
                <>
                  {!isSpecialEntered && (
                    <p className={styles.speechBubble}>
                      {SPECIAL_AREA_MISSION_IDS.length}エリアクリアしよう
                    </p>
                  )}
                  <Button
                    text="賞品に応募"
                    styleType="primary"
                    addClass={[styles.spotButton]}
                    disabled={true}
                  />
                </>
              ) : (
                <>
                  <p className={styles.speechBubble}>浜通り賞が当たる</p>
                  <Button
                    text="賞品に応募"
                    styleType="primary"
                    handleClick={() => {
                      handleApplyClick(prizeData?.awardSpecial.url, prizeData?.awardSpecial.award);
                    }}
                    addClass={[styles.spotButton]}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {isOpenPrize && (
        <Dialog
          isOpen={isOpenPrize}
          handleClose={handleClosePrize}
          easyCloseMode={false}
          addClass={[styles.dialogPrize]}
        >
          <>
            <div className={styles.dialogPrizeHead}>
              <button
                type="button"
                className={styles.dialogPrizeCloseIconButton}
                onClick={handleClosePrize}
              >
                <img src={CloseIconWhite} alt="閉じる" className={styles.dialogPrizeCloseIcon} />
              </button>
            </div>
            <div
              className={[
                styles.dialogPrizeBody,
                currentPrizeData && getClassName(currentPrizeData?.award),
              ].join(' ')}
              data-dialog-award={currentPrizeData && getClassName(currentPrizeData?.award)}
            >
              <p
                className={styles.dialogPrizeTitle}
                dangerouslySetInnerHTML={{
                  __html: currentPrizeData?.prize.name || '',
                }}
              />
              <div className={styles.dialogPrizeCard}>
                <div className={styles.dialogPrizeCardHead}>
                  <img
                    src={require(`components/pages/Prizes/images/${getPrizeFileName(
                      currentPrizeData?.award || '',
                      currentPrizeData?.index || 0
                    )}`)}
                    alt=""
                    className={styles.dialogPrizeCardHeadImage}
                  />
                  <span className={styles.dialogPrizeWinnerCount}>
                    {currentPrizeData && currentPrizeData.prize.winnerCount}
                  </span>
                </div>
                <div className={styles.dialogPrizeCardBody}>
                  <span
                    className={styles.dialogPrizeCardText}
                    dangerouslySetInnerHTML={{
                      __html: String(currentPrizeData?.prize.description || ''),
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={styles.dialogPrizeFoot}>
              <Button text="閉じる" styleType="secondary" handleClick={handleClosePrize}></Button>
            </div>
          </>
        </Dialog>
      )}
      {isOpenApply && (
        <Dialog
          isOpen={isOpenApply}
          handleClose={handleCloseApply}
          addClass={[styles.dialogApply]}
          easyCloseMode={false}
        >
          <div className={styles.dialogApplyCard}>
            <div className={styles.dialogApplyCardHead}>
              <button
                type="button"
                className={styles.dialogCloseIconButton}
                onClick={handleCloseApply}
              >
                <img src={CloseIcon} alt="閉じる" className={styles.dialogCloseIcon} />
              </button>

              <p className={styles.dialogApplyCardTitle}>賞品に応募する</p>
              <p className={styles.dialogApplyCardLead}>
                {selectedAward === 'SS賞' && <strong>当選確率2倍で応募できます。</strong>}
                {selectedAward === 'S賞' && <strong>S・A・B・C賞の賞品が当たります。</strong>}
                {selectedAward === 'A賞' && <strong>A・B・C賞の賞品が当たります。</strong>}
                {selectedAward === 'B賞' && <strong>B・C賞の賞品が当たります。</strong>}
                {selectedAward === 'C賞' && <strong>C賞の賞品が当たります。</strong>}
                {selectedAward === '浜通り賞' && <strong>浜通り賞の賞品が当たります。</strong>}
                {selectedAward !== '浜通り賞' && (
                  <>
                    <br />
                    一度賞品に応募すると、これ以降はクリア数が増えても応募できませんのでご注意ください。
                    <br />
                    ※浜通り賞は別途応募可能です
                  </>
                )}
              </p>
            </div>
            <div className={styles.dialogApplyCardFoot}>
              <a
                href={applyUrl}
                target="_blank"
                className={styles.dialogApplyCardActionButton}
                rel="noreferrer"
              >
                応募する
              </a>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
};
